<div class="firma-upload-container">
  <!-- Titulo y descripcion -->
  <div class="firma-header">
    <h3 class="firma-title">Firma Digital</h3>
    <p class="firma-description">
      Dibuje su firma para incluirla en recetas y documentos digitales.
    </p>
  </div>

  <!-- Vista previa de firma actual -->
  <div
    class="firma-preview-section"
    *ngIf="currentSignatureUrl"
  >
    <label class="section-label">Firma actual:</label>
    <div class="firma-preview current">
      <img
        [src]="currentSignatureUrl"
        alt="Firma actual"
        class="firma-image"
        (error)="currentSignatureUrl = null"
      />
    </div>
    <div class="sync-status" *ngIf="syncedToApi !== null">
      <mat-icon [class.synced]="syncedToApi">{{
        syncedToApi ? "cloud_done" : "cloud_off"
      }}</mat-icon>
      <span>{{
        syncedToApi ? "Sincronizada con Recetario" : "Pendiente de sincronizar"
      }}</span>
    </div>
  </div>

  <!-- Canvas para dibujar firma -->
  <div class="canvas-section">
    <app-firma-canvas
      [width]="RECOMMENDED_WIDTH"
      [height]="RECOMMENDED_HEIGHT"
      (firmaGenerada)="onFirmaFromCanvas($event)"
      (firmaBorrada)="onCanvasBorrado()"
    ></app-firma-canvas>
  </div>

  <!-- Mensaje de error -->
  <div class="error-message" *ngIf="state.error">
    <mat-icon>error</mat-icon>
    <span>{{ state.error }}</span>
  </div>

  <!-- Indicador de exito -->
  <div class="success-message" *ngIf="state.success">
    <mat-icon>check_circle</mat-icon>
    <span>Firma actualizada correctamente</span>
  </div>
</div>
